import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { DevHostComponent } from './dev/dev-host.component';
import { GateComponent } from './gate/gate.component';
import { ShellComponent } from './shell/shell.component';

const STORAGE_KEY = 'pre2post-gate';

@Component({
  selector: 'orange-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ShellComponent, DevHostComponent, GateComponent],
  template: `
    @if (authenticated()) {
      <a class="skip-link" href="#main" i18n="@@skipLink">Sari la conținut</a>
      <orange-shell />
      <orange-dev-host />
    } @else {
      <orange-gate (granted)="unlock()" />
    }
  `,
})
export class AppComponent {
  readonly authenticated = signal(sessionStorage.getItem(STORAGE_KEY) === 'granted');

  unlock(): void {
    sessionStorage.setItem(STORAGE_KEY, 'granted');
    this.authenticated.set(true);
  }
}
